import { setURLParams } from 'actions';
import ToggleButton from 'components/ToggleButton';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getParams } from 'selectors/nav';
import { useSelector } from 'store';
import logEvent from 'utils/analytics';

type ComponentProps = {
  offsetResource?: string;
};

const IncludeDeletedFilter: React.FC<ComponentProps> = ({ offsetResource }) => {
  const dispatch = useDispatch();
  const includeDeleted = useSelector((state) => getParams(state).include_deleted === 'true');

  const handleToggle = (): void => {
    const next = includeDeleted ? 'false' : 'true';
    logEvent(`include-deleted-filter-${next}`);
    dispatch(
      setURLParams({
        include_deleted: next,
        ...(offsetResource != null ? { [`${offsetResource}__offset`]: '0' } : {}),
      })
    );
  };

  return (
    <div className="flex items-center gap-2 self-end">
      <span className="text-body whitespace-no-wrap">Include deleted</span>
      <ToggleButton
        dataTestid="include-deleted-toggle"
        isOn={includeDeleted}
        handleToggleClick={handleToggle}
      />
    </div>
  );
};

export default IncludeDeletedFilter;
